<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12> 
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">
            <router-link style="text-decoration: none;" :to="{ name: 'Dashboard'}">
              <b class="title primary white--text">
                Manage Lead
              </b>
            </router-link>
          </v-toolbar-title>
          <v-spacer />
          <v-select
            solo
            clearable
            v-model="selectedCustomer"
            :items="getLeadedCustomers"
            label="Buyers"
          >
          </v-select>
          <v-spacer />
          <v-select
            solo
            clearable
            v-model="statusFilter"
            :items="['PENDING', 'CANCELLED', 'CONFIRMED', 'ALL']"
            label="Filter"
          >
          </v-select>
          <v-spacer></v-spacer> 
            <router-link style="text-decoration: none;" :to="'informations/product-lead-report/'" >
              <v-btn outlined>
                <v-icon left class="primary--text">mdi-alert-box</v-icon> Lead Product
              </v-btn>
            </router-link>
          <v-spacer></v-spacer>
          <v-btn outlined @click="addLeadDialog()">
            <v-icon left color="teal">add</v-icon> New Lead
          </v-btn>
        </v-toolbar>

        <v-data-table
          :headers="leadHeader"
          :items="leadsByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-menu bottom right offset-y :close-on-content-click="false">
                <v-btn class="mx-0" slot="activator" icon dark>
                  <v-icon color="primary">more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-group :prepend-icon="'picture_as_pdf'" no-action>
                    <template v-slot:activator>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Actions</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>

                    <v-list-tile
                      v-if="props.item['leadHistory']"
                      @click="openHistory(props.item)"
                      color="primary"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">history</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Processed Lead</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="props.item['orignalLead']"
                      @click="openOrignal(props.item)"
                      color="primary"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">trip_origin</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title> Original Lead </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="props.item['status'] == 'PENDING'"
                      @click="editLead(props.item)"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Edit Lead</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="deleteLead(props.item)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">delete</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Delete Lead</v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                </v-list>
              </v-menu>
            </td>
            <td>
              <!-- <v-icon :disabled="props.item['status']=='CANCELLED' || props.item['status']=='CONFIRMED'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon> -->
              <v-icon
                :disabled="
                  props.item['status'] == 'CANCELLED' ||
                  props.item['status'] == 'CONFIRMED' ||
                  (getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                    ? isShopUserExists(props.item.shopLeadUserId)
                      ? false
                      : true
                    : false)
                "
                @click="openProd(props.item)"
                color="primary"
                >remove_red_eye</v-icon
              >
            </td>
            <td>
              <b>{{ props.item["leadNumber"] }}</b>
            </td>
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }} </b>
            </td>
            <!-- <td>
              <b>{{props.item.leadTime}}</b>
            </td> -->
            <td>
              <b v-if="props.item.buyerId">{{
                getCustomerName(props.item.buyerId)
              }}</b>
              <b v-else-if="isShopUserExists(props.item.shopLeadUserId)">{{
                getShopUserName(props.item.shopLeadUserId)
              }}</b>
              <b v-else>
                <v-btn @click="addShopUser(props.item)">{{
                  props.item.shopLeadUserName
                }}</v-btn>
                <br />
                <div>New Customer. Click To Create Buyer.</div>
              </b>
            </td>
            <!-- <td>
              <b>{{
                props.item["invoiceDate"]
                  ? new Date(props.item.invoiceDate).toLocaleDateString("en-GB")
                  : ""
              }}</b>
            </td> -->
            <td>
              <b class="font-weight-bold red--text">{{
                getTotal(props.item) || 0 | amount
              }}</b>
            </td>
            <!-- <td>
              <b>{{props.item['remainingAmountLead']}}</b>
            </td> -->
            <!-- <td>
              <b>{{props.item['.key']}}</b>
            </td> -->
            <!-- <td>
              <b>{{getFirmName(props.item.firm)}}</b>
            </td> -->
            <td>
              <b>{{ props.item["leadType"] }}</b>
            </td>
            <td>
              <b>{{ props.item["status"] }}</b>
            </td>
            <!-- <td v-if="props.item['status']!='CANCELLED'">
              <v-btn v-if="props.item['status'] == 'PENDING'" icon class="mx-0" @click="cancelLead(props.item)">
                <v-icon color="pink">cancel</v-icon>
              </v-btn>
              <v-btn v-else icon class="mx-0" @click="dispatrchLead(props.item)">
                <v-icon color="pink">commute</v-icon>
              </v-btn>
            </td>
            <td v-else></td> -->
            <!-- <td>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon class="mx-0">
                    <v-icon color="blue">print</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="printLead(props.item, true)">
                    <v-list-tile-title> Taxable Print </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="printLead(props.item, false)">
                    <v-list-tile-title> Simple Print </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td> -->
            <!-- <td>
              <v-icon v-if="props.item['leadHistory']" @click="openHistory(props.item)" color="primary">history</v-icon>
            </td>
              <td>
              <v-icon v-if="props.item['orignalLead']" @click="openOrignal(props.item)" color="primary">trip_origin</v-icon>
            </td>
            <td>
              <v-btn icon class="mx-0" v-if="props.item['status'] == 'PENDING'" @click="editLead(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteLead(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td> -->
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="leadDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <!-- <span class="headline">Create Lead</span> -->
          <span class="headline" v-if="isEdit">Edit Lead</span>
          <span class="headline" v-else>Create Lead</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3 md3>
                <v-switch
                  :disabled="isEdit"
                  v-model="isBuyer"
                  :label="`${isBuyer ? 'Sale Lead' : 'Purchase Lead'}`"
                ></v-switch>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 sm3 md3>
                <v-switch
                  :disabled="isEdit"
                  v-model="multiFirm"
                  @change="restructureProductList()"
                  :label="`Multi-firm`"
                ></v-switch>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 sm4 md4>
                <v-select
                  dense
                  :disabled="multiFirm"
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-model="selectedFirm"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-select
                  v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                  v-model="selectedBuyer"
                  :label="
                    isBuyer ? 'Select or add Buyer' : 'Select or add Seller'
                  "
                  autocomplete
                  :disabled="isEdit"
                  item-text="name"
                  return-object
                  @keyup.native.enter="addCustomer"
                >
                </v-select>
              </v-flex>
              <v-spacer/>

              <v-flex xs12 sm3 md3>
                <v-select
                    item-text="name"
                    item-value="id"
                    :items="currentLeadType"
                    v-model="leadType"
                    label="Choose Lead Type"
                ></v-select>
              </v-flex>
              <v-spacer/>      
              <v-flex xs12 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerLead"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date"
                    label="Lead Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="date"
                    @input="datepickerLead = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 sm1 md1>
                <v-text-field
                  v-model="leadNumber"
                  prefix="#"
                  label="Lead Number"
                  placeholder="Enter Lead Number"
                  required
                ></v-text-field>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 sm6 md6 v-if="leadsSetting && leadsSetting.isLeadTime">
                <v-time-picker label="Lead Time" v-model="leadTime"></v-time-picker>
              </v-flex >
              <v-flex xs12 sm2 md2 v-if="leadsSetting && leadsSetting.isStaffSelection">
                <v-select
                  dense
                  :items="staffByBrand"
                  label="Sold By"
                  v-model="soldBy"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2 md2 v-if="isRestaurantBusiness && !multiFirm">
                <v-select
                  dense
                  :items="floorList"
                  label="Select Floor"
                  item-text="name"
                  item-value="name"
                  @change="getTableList()"
                  v-model="floorName"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2 md2 v-if="tableList.length">
                <v-select
                  dense
                  :items="tableList"
                  label="Select Table"
                  return-object
                  item-text="name"
                  item-value="name"
                  v-model="tableName"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-combobox
                  v-model="productsToLead"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  @change="addToBucket()"
                  label="Select Product"
                  multiple
                ></v-combobox> -->
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout wrap>
                  <template v-for="(item, index) in items">
                    <v-flex
                      :key="index + item.productId"
                      xs4
                      sm4
                      md4
                      style="display: inline-flex"
                    >
                      <v-select
                        style="width: 90%"
                        dense
                        autocomplete
                        item-text="name"
                        :item-value="'name'"
                        :items="productListByBrand"
                        label="Product Name"
                        v-model="item.productName"
                        @change="restructureProductList(index)"
                      ></v-select>
                      <v-text-field
                        style="width: 10%"
                        v-if="isRestaurantBusiness"
                        disabled
                        type="number"
                        v-model="item.call"
                        label="Call"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex :key="index + item.productName" xs1 sm1 md1>
                      <v-text-field
                        v-if="item.productName"
                        type="number"
                        v-model.number="item.quantity"
                        label="Quantity"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs2 sm2 md2 :key="index + item.unit">
                      <v-select
                        v-if="item.productName"
                        dense
                        item-text="text"
                        item-value="value"
                        :items="availableProductUnit[item.productId].units"
                        @change="unitChange(item)"
                        label="Select unit"
                        v-model="item.unit"
                      ></v-select>
                    </v-flex>
                    <v-flex
                      :key="index + item.productName + 'RATE'"
                      xs2
                      sm2
                      md2
                    >
                      <v-text-field
                        v-if="item.productName"
                        type="number"
                        v-model.number="item.rate"
                        label="Rate"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      :key="index + item.productName + 'total'"
                      xs2
                      sm2
                      md2
                    >
                      <v-text-field
                        v-if="item.productName"
                        type="number"
                        :value="
                          Number.parseFloat((item.rate ? Number.parseFloat(item.rate) : 0) *
                          (item.rate ? Number.parseFloat(item.quantity) : 0)).toFixed(2)
                        "
                        :disabled="true"
                        label="Total"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex :key="index + item.productName + 'add'" xs1 sm1 md1>
                      <v-btn
                        icon
                        color="primary"
                        v-if="index == items.length - 1 && item.productName"
                        @click="addProd()"
                      >
                        <v-icon>add_circle</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        @click="removeProd(index)"
                        v-else-if="item.productName"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="leadDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            :disabled="
              !items.length ||
              !selectedBuyer ||
              !items[0].productId ||
              (multiFirm ? false : !selectedFirm)
            "
            @click="addLead()"
            flat
            >{{ isEdit ? "Save" : "Create" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="invoiceLead"
      width="800"
      v-if="selectedLead && selectedLead['.key']"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Lead details:-
          <!-- {{selectedLead['.key']}} -->
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="productInvoiceHeader"
            :items="selectedLead.items"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <tr :class="props.item.completed ? 'green-bg' : ''">
                <td v-if="isRestaurantBusiness">
                  <b>{{ props.item["call"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["productName"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["quantity"] }}</b>
                </td>
                <td>
                  <b>{{ props.item.unit }}</b>
                </td>
                <td>
                  <b
                    ><v-text-field
                      type="number"
                      v-model.number="props.item.rate"
                      label="Product Rate"
                    ></v-text-field
                  ></b>
                </td>
                <td>
                  <v-text-field
                    type="number"
                    :value="
                      (props.item.rate
                        ? Number.parseFloat(props.item.rate)
                        : 0) *
                      (props.item.rate
                        ? Number.parseFloat(props.item.quantity)
                        : 0)
                    "
                    :disabled="true"
                    label="Total"
                  >
                  </v-text-field>
                </td>
              </tr>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="invoiceLead = false">Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="createInvoice()"
            >Create Order
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="leadHistory"
      width="800"
      v-if="selectedLead && selectedLead['.key']"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >{{
            modalMode == "history"
              ? "Proceesed Lead History:-"
              : "Orignal Lead:- "
          }}
          <!-- {{selectedLead['.key']}} -->
        </v-card-title>
        <v-card-text>
          <template v-if="modalMode == 'orignal'">
            <v-data-table
              :headers="productInvoiceHeader"
              :items="selectedLead.orignalLead"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <tr :class="props.item.completed ? 'green-bg' : ''">
                  <td v-if="isRestaurantBusiness">
                    <b>{{ props.item["call"] }}</b>
                  </td>
                  <td>
                    <b>{{ props.item["productName"] }}</b>
                  </td>
                  <td>
                    <b>{{ props.item["quantity"] }}</b>
                  </td>
                  <td>
                    <b>{{ props.item.unit }}</b>
                  </td>
                  <td>
                    <b>{{ props.item.rate }}</b>
                  </td>
                  <td>
                    <b>{{
                      (props.item.rate
                        ? Number.parseFloat(props.item.rate)
                        : 0) *
                      (props.item.rate
                        ? Number.parseFloat(props.item.quantity)
                        : 0)
                    }}</b>
                  </td>
                </tr>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </template>
          <template v-else>
            <v-stepper v-model="historyStep" vertical>
              <template v-for="(item, index) in selectedLead.leadHistory">
                <v-stepper-step :step="index + 1" :key="item['.key']">
                  <v-link @click="historyStep = index + 1">{{
                    new Date(item["date"]).toLocaleDateString("en-GB")
                  }}</v-link>
                </v-stepper-step>

                <v-stepper-content :step="index + 1" :key="index">
                  <v-card class="mb-12 invoice-stepper">
                    <v-layout row wrap style="padding: 30px">
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm12 md12>
                        <h2
                          style="text-decoration: underline; text-align: center"
                        >
                          Product List
                        </h2>
                        <template>
                          <v-data-table
                            :headers="productInvoiceHeader"
                            :items="item.items"
                            class="elevation-1 dashboardHead"
                          >
                            <template slot="items" slot-scope="props">
                              <tr
                                :class="props.item.completed ? 'green-bg' : ''"
                              >
                                <td v-if="isRestaurantBusiness">
                                  <b>{{ props.item["call"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item["productName"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item["quantity"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item.unit }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item.rate }}</b>
                                </td>
                                <td>
                                  <b>{{
                                    (props.item.rate
                                      ? Number.parseFloat(props.item.rate)
                                      : 0) *
                                    (props.item.rate
                                      ? Number.parseFloat(props.item.quantity)
                                      : 0)
                                  }}</b>
                                </td>
                              </tr>
                            </template>
                            <template slot="no-data">No Items</template>
                          </v-data-table>
                        </template>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
              </template>
            </v-stepper>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="leadHistory = false">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
// import { convertToLead, convertToLeadWithoutGST } from "../../utils/leadPdf";
export default {
  data() {
    return {
      productsToLead: [],
      items: [],
      isEdit: false,
      leadDialog: false,
      isBuyer: true,
      invoiceLead: false,
      multiFirm: false,
      historyStep: 1,
      selectedLead: null,
      selectedBuyer: null,
      selectedFirm: null,
      leadTime : null,
      soldBy : null,
      availableProductUnit : {},
      date: new Date().toISOString().substr(0, 10),
      datepickerLead: false,
      leadsSetting : null,
      statusFilter: "ALL",
      leadNumber: null,
      leadHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      isCallAdded: false,
      tableList: [],
      leadType:null,
      currentLeadType:[        
        'Social Media',
        'Website',
        'Magazine',
        'News Paper',
        'Reference',
        'Normal',
      ],
      selectedCustomer: null,
      leadHeader: [
        { text: "Action", value: "edit" },
        { text: "View", value: "view" },
        { text: "Lead Number", value: "leadNumber" },
        { text: "Lead Date", value: "date", sortable: true },
        // { text: "Lead Time", value: "time", sortable: true },
        { text: "Customer Name", value: "name" },
        // { text: "Invoice Date", value: "date", sortable: true },
        { text: "Total Amount", value: "name" },
        { text: "Lead Type", value: "leadType" },
        { text: "Status", value: "status" },
        // { text: "Print", value: "print" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "buyers",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "sellers",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "firms",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "leads",
        this.$root.$firebaseRefs.leads
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "buyerById",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "sellerById",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsObject(
      "productById",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "termsAndConditions",
      this.$root.$firebaseRefs.termsAndConditions
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "bankById",
      this.$root.$firebaseRefs.account
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firmInfrastructure",
      this.$root.$firebaseRefs.firmInfrastructure
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "leadSettings",
      this.$root.$firebaseRefs.leadSetting
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
        "staffs",
        this.$root.$firebaseRefs.staff
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
    this.getCurrentSettings();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      let prod = this.products.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (!this.multiFirm
            ? this.selectedFirm
              ? item["firm"] === this.selectedFirm
              : false
            : true)
        );
      });
      prod.map((p, index) => {
        let productsWithSimilarCompostion = this.products.filter((item) => {
          return (
            item[".key"] == p[".key"] ||
            (item["brand"] === this.selectedBrand &&
              (!!item["composition"]
                ? _.isEqual(item["composition"], p["composition"])
                : false))
          );
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    staffByBrand() {
      return this.staffs
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            (!this.multiFirm
            ? this.selectedFirm
              ? item["firm"] === this.selectedFirm
              : false
            : true) && 
            item["staffRole"] === "Salesman"
          );
        })
        .map((item) => {
          return {
            text: item["staffName"],
            value: item[".key"],
          };
        });
    },
    leadsByBrand() {
      return this.leads.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (this.selectedCustomer
            ? item.buyerId == this.selectedCustomer
            : true) &&
          (this.statusFilter != "ALL"
            ? item.status == this.statusFilter
            : true) &&
          !item.isPortfolio
        );
      });
    },
    getLeadedCustomers() {
      return this.buyersByBrand.map((b) => {
        return {
          text: b.name,
          value: b[".key"],
        };
      });
    },
    buyersByBrand() {
      return this.buyers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    sellersByBrand() {
      return this.sellers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    isRestaurantBusiness() {
      if (this.selectedFirm) {
        let firm = this.firms.find((item) => item[".key"] == this.selectedFirm);
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },
    floorList() {
      if (this.selectedFirm) {
        let firmInfrastructure = this.firmInfrastructure.find(
          (item) => item["firm"] == this.selectedFirm
        );
        return firmInfrastructure.floorDetails;
      }
      return [];
    },
    productInvoiceHeader() {
      let productInvoiceHeader = [
        { text: "Name", value: "Name" },
        { text: "Quantity", value: "Taxable" },
        { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" },
        { text: "Total", value: "total" },
      ];
      if (this.isRestaurantBusiness) {
        productInvoiceHeader = [{ text: "Call", value: "call" }].concat(
          productInvoiceHeader
        );
      }
      return productInvoiceHeader;
    },
  },
  watch: {
    floorName: {
      handler(newVal, oldVal) {
        this.getTableList();
      },
      deep: true,
    },
    leadSettings : {
      handler(newVal, oldVal) {
        this.getCurrentSettings();
      },
      deep: true,
    }
  },
  methods: {
    getCurrentSettings(){
       this.leadsSetting = this.leadSettings.find(i => i.brand == this.selectedBrand)
    },
    // async printLead(invoiceData, isGST) {
    //   let firm = this.firms.filter(
    //     (item) => item[".key"] === invoiceData["firm"]
    //   )[0];
    //   let customer = invoiceData.isBuyer
    //     ? this.buyerById[invoiceData.buyerId]
    //     : this.sellerById[invoiceData.buyerId];
    //   firm.address = this.getAddress(firm);
    //   customer.address = this.getAddress(customer);
    //   let termsAndConditions = this.getTermsAndConditions(invoiceData);
    //   let gstTotal = this.calculateGSTInvoice(customer, invoiceData, firm);
    //   if (isGST) {
    //     await convertToLead({
    //       invoiceData: invoiceData,
    //       firm: firm,
    //       customer: customer,
    //       terms: termsAndConditions[0],
    //       gstTotal: gstTotal,
    //     }).then((doc) => {
    //       pdfMake.createPdf(doc).download();
    //     });
    //   } else {
    //     await convertToLeadWithoutGST({
    //       invoiceData: invoiceData,
    //       firm: firm,
    //       customer: customer,
    //       terms: termsAndConditions[0],
    //       gstTotal: gstTotal,
    //     }).then((doc) => {
    //       pdfMake.createPdf(doc).download();
    //     });
    //   }
    // },
    // getTermsAndConditions(invoiceData) {
    //   let termsAndConditions = this.termsAndConditions.filter(
    //     (item) =>
    //       item["brand"] === this.selectedBrand &&
    //       item["firm"] === invoiceData.firm
    //   );
    //   if (termsAndConditions.length) {
    //     if (termsAndConditions[0].bank) {
    //       let banks = [];
    //       termsAndConditions[0].bank.map((bankId) => {
    //         let bank = this.bankById[bankId];
    //         bank.address = this.getAddress(bank);
    //         banks.push(bank);
    //       });
    //       termsAndConditions[0].banks = banks;
    //     } else {
    //       termsAndConditions[0].banks = [];
    //     }
    //   } else {
    //     termsAndConditions = [
    //       {
    //         termsAndConditions: "",
    //         banks: [],
    //       },
    //     ];
    //   }
    //   return termsAndConditions;
    // },
    // getAddress(item) {
    //   if (!item) {
    //     return "";
    //   }
    //   let address =
    //     (item.village ? item.village + " - " : "") +
    //     (item.block ? item.block + " - " : "") +
    //     (item.tehsil ? item.tehsil + " - " : "") +
    //     (item.district ? item.district + " - " : "") +
    //     (item.state ? item.state + " - " : "") +
    //     (item.country ? item.country + " - " : "");
    //   address = address.substring(0, address.length - 2);
    //   return address;
    // },
    calculateGSTInvoice(currentUser, invoice, firm) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          let prod = this.products.filter(
            (p) => p[".key"] === item["productId"]
          )[0];
          item["taxableGST_rate"] = prod["taxableGST_rate"];
          item.HSN_code = prod["HSN_code"];
          item.basicPrice = Number.parseFloat(
            item.rate * item.quantity
          ).toFixed(2);
          item.GSTValue = Number.parseFloat(
            item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)
          ).toFixed(2);
          item.totlePrice = Number.parseFloat(
            Number.parseFloat(item.basicPrice) +
              Number.parseFloat(item.GSTValue)
          ).toFixed(2);
          let GST = item["taxableGST_rate"];
          if (
            !currentUser.state ||
            (firm &&
              currentUser.state &&
              Number.parseFloat(GST) &&
              firm.state === currentUser.state)
          ) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST / 2;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST / 2;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
          }
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
          IGST_val += parseFloat(item["IGST_val"]);
        });
      return { SGST_val, CGST_val, IGST_val };
    },
    addLeadDialog() {
      this.leadDialog = true;
      this.productsToLead = [];
      this.items = [
        {
          productName: null,
          productId: null,
          quantity: 1,
          unit: null,
          rate: 0,
        },
      ];
      this.isEdit = false;
      this.invoiceLead = false;
      this.selectedBuyer = null;
      this.accountType = null;
      // this.selectedFirm = null;
      let leads = this.leads.filter(
        (i) => i["brand"] === this.selectedBrand && i.status == "PENDING"
      );
      this.leadNumber = leads.length + 1;
      this.selectedLead = null;
    },
    openHistory(item) {
      this.selectedLead = item;
      this.leadHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal(item) {
      this.selectedLead = item;
      this.leadHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd(item) {
      this.selectedLead = item;
      this.invoiceLead = true;
    },
    getTotal(item) {
      let total = 0;
      item.items.map((i) => {
        total += Number.parseFloat(
          Number.parseFloat(i.rate) * Number.parseFloat(i.quantity)
        );
      });
      return total;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists(id) {
      let buyers = this.buyers.filter((item) => item.shopUserId == id);
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName(id) {
      let buyers = this.buyers.filter((item) => item.shopUserId == id);
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },
    addToBucket() {
      let tempIts = this.items;
      this.items = [];
      this.productsToLead.map((prod, index) => {
        if (typeof prod == "string") {
          this.productsToLead.splice(index, 1);
        }
      });
      this.productsToLead.map((prod, index) => {
        let selectedProd = tempIts.filter(
          (item) => item["productId"] == prod[".key"]
        )[0];
        let itemToAdd = {
          productName: prod.name,
          similar: prod.similar,
          productId: prod[".key"],
          quantity:
            selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
          unit:
            selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
          rate:
            selectedProd && selectedProd.rate
              ? selectedProd.rate
              : this.isBuyer
              ? prod["sellingPrice"] || 0
              : prod["purchasingPrice"] || 0,
        };
        if (this.multiFirm) {
          itemToAdd["firm"] = prod.firm;
        }
        this.items.push(itemToAdd);
      });
    },
    restructureProductList(indexMain) {
      this.items.map((item, index) => {
        if (indexMain ? index == indexMain : true) {
          let prod = this.products.filter(
            (item1) =>
              item1["name"] == item.productName &&
              item1["brand"] === this.selectedBrand
          )[0];
         
          this.items[index]["productName"] = prod.name;
          this.items[index]["productId"] = prod[".key"];
          this.items[index]["quantity"] = 1;
          this.items[index]["unit"] = prod.unit;
          this.items[index]["rate"] = this.isBuyer
            ? prod["sellingPrice"] || 0
            : prod["purchasingPrice"] || 0;
          if(prod.unitsDeatilsAdded) {
            this.availableProductUnit[prod[".key"]] = {
              units : prod.unitsDetails.map((prod)=> { 
                  return prod.unit 
              })
            }
          } else {
            this.availableProductUnit[prod[".key"]] = {
              units : this.units
            }
          }
          if (this.multiFirm) {
            this.items[index]["firm"] = prod.firm;
          }
          if (this.isRestaurantBusiness) {
            let call = 0;
            if (this.items.length > 1) {
              call = Math.max.apply(
                Math,
                this.items.map(function (o) {
                  return o.call || 0;
                })
              );
            }
            if (!this.isCallAdded) {
              call++;
              this.isCallAdded = !this.isCallAdded;
            }
            this.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList() {
      this.tableList = this.floorList.find(
        (item) => item.name == this.floorName
      ).tables;
    },
    addProd() {
      let itemToAdd = {
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0,
      };
      this.items.push(itemToAdd);
    },
    removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState() {
      let firm = this.firms.filter(
        (item) => item[".key"] == this.selectedFirm
      )[0];
      return firm["state"];
    },
    addCustomer: function (e) {
      let obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState(),
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser(lead) {
      if (confirm("Are you sure you want to create buyer?")) {
        let obj = {
          name: lead.shopLeadUserName,
          shopUserId: lead.shopLeadUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState(),
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice() {
      let key = this.selectedLead[".key"];
      delete this.selectedLead[".key"];

      if (!this.selectedLead.buyerId && this.selectedLead.shopLeadUserId) {
        let buyer = this.buyers.filter(
          (item) => item.shopUserId == this.selectedLead.shopLeadUserId
        )[0];
        if (buyer) {
          this.selectedLead["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.leads
        .child(key)
        .set(this.selectedLead)
        .then((snap) => {
          this.selectedLead = null;
          this.$router.push({ path: `/lead-to-invoice/${key}` });
          this.invoiceLead = false;
        });
    },
    cancelLead(lead) {
      let key = lead[".key"];
      delete lead[".key"];
      lead["status"] = "CANCELLED";
      this.$root.$firebaseRefs.leads
        .child(key)
        .set(lead)
        .then((snap) => {});
    },
    editLead(lead) {
      if (lead.multiFirm) {
        this.multiFirm = true;
      }
      if(lead.leadTime) {
        this.leadTime = lead.leadTime;
      }
      if(lead.soldBy) {
        this.soldBy = lead.soldBy
      }
      this.productsToLead = [];
      this.items = lead.items;
      this.selectedFirm = lead.firm;
      (this.date = new Date(lead.date).toISOString().substr(0, 10)),
      (this.leadNumber = lead.leadNumber),
      (this.leadType = lead.leadType),
        (this.selectedLead = lead);
      this.isBuyer = lead.isBuyer;
      if (lead.isBuyer) {
        this.selectedBuyer = this.buyerById[lead.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[lead.buyerId];
      }
      if (this.isRestaurantBusiness) {
        this["floorName"] = lead.floorName;
        this["tableName"] = lead.tableName;
      }
       this.items.map((item, index) => {
         let prod = this.products.filter(
           (item1) =>
             item1["name"] == item.productName &&
             item1["brand"] === this.selectedBrand
         )[0];
       
         if(prod.unitsDeatilsAdded) {
           this.availableProductUnit[prod[".key"]] = {
             units : prod.unitsDetails.map((prod)=> { 
                 return prod.unit 
             })
           }
         } else {
           this.availableProductUnit[prod[".key"]] = {
             units : this.units
           }
         }
       });
      this.leadDialog = true;
      this.isEdit = true;

      // this.items.map((item1,index)=>{
      //   let productsWithSimilarCompostion = this.products.filter((item) => {
      //   return (item['.key'] == item1['productId'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],item1['composition']) : false)
      //     ))
      //   });
      //   this.items[index]['similar'] = productsWithSimilarCompostion;
      //   // this.productsToLead.push(this.productById[item1.productId])
      //   let obj = this.productById[item1.productId];
      //   obj['.key'] = item1.productId;
      //   let sim = this.products.filter((item) => {
      //   return (item['.key'] ==obj['.key'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],obj['composition']) : false)
      //     ))
      //   });
      //   obj['similar'] = sim;
      //   this.productsToLead.push(obj)
      // })
    },
    unitChange(item){
      let prod =  this.products.find(i => i['.key'] == item['productId']);
       if(prod.unitsDeatilsAdded) {
        prod.unitsDetails.map((prod)=> { 
            if(prod['unit'] == item.unit) {
              let rate = this.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
              if(rate) {
                item.rate = rate;
              }
            }
        });
      } 
    },
    addLead() {
      this.items.map((i, index) => {
        if (!i.productName) {
          this.items.splice(index, 1);
        }
      });
      let leadObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        leadNumber: this.leadNumber,
        leadType: this.leadType,
        items: this.items,
      };
      //   status: 'PENDING'
      // }
      // this.$root.$firebaseRefs.Leads.push(LeadObj);
      if (this.multiFirm) {
        leadObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        leadObj["floorName"] = this.floorName;
        leadObj["tableName"] = this.tableName;
      }
      if(this.leadsSetting && this.leadsSetting.isLeadTime) {
        leadObj['leadTime'] = this.leadTime;
      }
      if(this.leadsSetting && this.leadsSetting.isStaffSelection) {
        leadObj['soldBy'] = this.soldBy;
      }
      if (this.isEdit) {
        leadObj["status"] = this.selectedLead["status"];
        leadObj["buyerId"] = this.selectedLead["buyerId"];
        this.$root.$firebaseRefs.leads
          .child(this.selectedLead[".key"])
          .set(leadObj)
          .then((snap) => {
            this.isEdit = false;
          });
      } else {
        leadObj["status"] = "PENDING";
        this.$root.$firebaseRefs.leads.push(leadObj);
      }
      this.isCallAdded = false;
      this.leadDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToLead = [];
    },
    deleteLead(lead) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.leads.child(lead[".key"]).remove();
      }
    },
  },
};
</script>
<style>
.status-filter.v-select .v-select__selections,
.status-filter.v-icon {
  color: #fff !important;
}
.status-filter.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #fff;
}
</style>
<style scoped>
.invoice-stepper {
  border: 1px solid #01579b;
  border-radius: 4px;
  background: #fafafa;
}
.green-bg {
  background: #d7ffd7;
}
</style>



// WEBPACK FOOTER //
// src/components/RecordLead/RecordLead.vue